import { render, staticRenderFns } from "./PhoenixVerify.vue?vue&type=template&id=84f95310"
import script from "./PhoenixVerify.vue?vue&type=script&lang=js"
export * from "./PhoenixVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports